import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, Parallax, Keyboard, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './CurrentProjects.css';

function CurrentProjects() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const swiperRef = useRef(null);
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);

  const handleSlideChange = (swiper) => {
    // Swiper returns realIndex when loop is enabled
    setCurrentSlide(swiper.realIndex + 1);
  };

  const goToPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const goToNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const projects = [
    {
      id: 1,
      image: '/WebsitePhotos/design.jpg',
      tag: 'OUR VISION',
      title: 'DESIGN',
      description: 'Crafting visual identities and user experiences that resonate. We transform ideas into compelling designs that communicate your brand\'s essence and engage your audience.',
      buttonText: 'Take A Look',
      link: '#'
    },
    {
      id: 2,
      image: '/WebsitePhotos/motion.jpg',
      tag: 'INSPIRATION',
      title: 'MOTION',
      description: 'Bringing static concepts to life through dynamic motion graphics and animations. We create engaging visual narratives that capture attention and tell your story.',
      buttonText: 'See More',
      link: '#'
    },
    {
      id: 3,
      image: 'https://i.ibb.co/nsM9MSZZ/129770.jpg',
      tag: '',
      title: 'ENGINE',
      description: 'Building powerful, scalable systems that drive your business forward. Our engineering solutions combine cutting-edge technology with robust architecture.',
      buttonText: 'Take A Look',
      link: '#'
    }
  ];

  return (
    <section className="creative-fullpage--slider scroll-fade-in">
      <div className="banner-horizental">
        <Swiper
          ref={swiperRef}
          className="swiper-container-h"
          modules={[Navigation, Pagination, Autoplay, Parallax, Keyboard, Mousewheel]}
          spaceBetween={0}
          slidesPerView={1}
          speed={1600}
          parallax={true}
          loop={true}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false
          }}
          keyboard={{
            enabled: true,
            onlyInViewport: true
          }}
          mousewheel={{
            eventsTarget: '.swiper-slide',
            sensitivity: 1
          }}
          navigation={false}
          pagination={{
            el: '.swiper-pagination',
            type: 'progressbar'
          }}
          onSlideChange={handleSlideChange}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            setCurrentSlide(swiper.realIndex + 1);
          }}
        >
          {projects.map((project, index) => (
            <SwiperSlide key={project.id}>
              <div className="slider-inner" data-swiper-parallax="100">
                <img src={project.image} alt={project.title} />
                <div className="swiper-content" data-swiper-parallax="2000">
                  <div className="title-area">
                    {project.tag && <p className="tag">{project.tag}</p>}
                    <a href={project.link} className="title">{project.title}</a>
                  </div>
                  <p className="disc">
                    {project.description.split('<br>').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i < project.description.split('<br>').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="slider-pagination-area">
            <h5 className="slide-range one">01</h5>
            <div className="swiper-pagination swiper-pagination-progressbar swiper-pagination-horizontal"></div>
            <h5 className={`slide-range ${currentSlide === 3 ? 'three' : 'current'}`}>
              {String(currentSlide).padStart(2, '0')}
            </h5>
          </div>
        </Swiper>
        {/* Custom navigation buttons - only one pair */}
        <button 
          ref={prevButtonRef}
          className="custom-nav-btn custom-nav-prev" 
          onClick={goToPrev}
          aria-label="Previous slide"
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button 
          ref={nextButtonRef}
          className="custom-nav-btn custom-nav-next" 
          onClick={goToNext}
          aria-label="Next slide"
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </section>
  );
}

export default CurrentProjects;

